<template>
  <el-dialog
    @close="handleClose"
    :modal-append-to-body="false"
    width="965px"
    :visible.sync="dialogFormVisible"
  >
    <!-- 联系企业form -->
    <el-form
      v-show="dialogtype == 'contactbusiness'"
      :model="contactbusinessform"
      :rules="rules"
      ref="contactbusinessform"
      label-width="170px"
    >
      <el-form-item :label="$t('Send To') + '：'">
        <p v-if="exhibitor && exhibitor.name">{{ exhibitor.name }}</p>
      </el-form-item>
      <el-form-item :label="$t('Trade Content') + '：'" prop="description">
        <el-input
          type="textarea"
          v-model="contactbusinessform.description"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Contact Information') + '：'" required>
        <el-col :span="7">
          <el-form-item prop="contactName">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Name')"
              v-model="contactbusinessform.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactNumber">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Mobile')"
              v-model="contactbusinessform.contactNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactEmail">
            <el-input
              style="width: 260px"
              :placeholder="$t('Your E-mail')"
              v-model="contactbusinessform.contactEmail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Company1') + '：'" prop="company">
        <el-input
          style="width: 300px"
          :placeholder="$t('Your Company')"
          v-model="contactbusinessform.companyName"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          style="width: 220px"
          @click="submitForm('contactbusinessform')"
          >{{ $t("SUBMIT") }}</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 联系主办form -->
    <el-form
      v-show="dialogtype == 'contactmain'"
      :model="contactmainform"
      :rules="rules"
      ref="contactmainform"
      label-width="170px"
    >
      <el-form-item :label="$t('Send To') + '：'">
        <p>中国国际自行车展览会组委会</p>
      </el-form-item>
      <el-form-item :label="$t('Trade Content') + '：'" prop="description">
        <el-input
          type="textarea"
          v-model="contactmainform.description"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Contact Information') + '：'" required>
        <el-col :span="7">
          <el-form-item prop="contactName">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Name')"
              v-model="contactmainform.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactNumber">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Mobile')"
              v-model="contactmainform.contactNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactEmail">
            <el-input
              style="width: 260px"
              :placeholder="$t('Your E-mail')"
              v-model="contactmainform.contactEmail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Company1') + '：'" prop="company">
        <el-input
          style="width: 300px"
          :placeholder="$t('Your Company')"
          v-model="contactmainform.companyName"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          style="width: 220px"
          @click="submitForm('contactmainform')"
          >{{ $t("SUBMIT") }}</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 发送预约 -->
    <el-form
      v-show="dialogtype == 'reserve'"
      :model="reserveform"
      :rules="rules"
      ref="reserveform"
      label-width="170px"
    >
      <el-form-item :label="$t('Send To') + '：'">
        <p v-if="exhibitor && exhibitor.name">{{ exhibitor.name }}</p>
      </el-form-item>
      <el-form-item :label="$t('Reservation') + '：'" prop="description">
        <el-input type="textarea" v-model="reserveform.description"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Contact Information') + '：'" required>
        <el-col :span="7">
          <el-form-item prop="contactName">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Name')"
              v-model="reserveform.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactNumber">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Mobile')"
              v-model="reserveform.contactNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactEmail">
            <el-input
              style="width: 260px"
              :placeholder="$t('Your E-mail')"
              v-model="reserveform.contactEmail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Company1') + '：'" prop="company">
        <el-input
          style="width: 300px"
          :placeholder="$t('Your Company')"
          v-model="reserveform.companyName"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          style="width: 220px"
          @click="submitForm('reserveform')"
          >{{ $t("SUBMIT") }}</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 询盘内容 -->
    <el-form
      v-show="dialogtype == 'ask'"
      :model="askform"
      :rules="rules"
      ref="askform"
      label-width="170px"
    >
      <el-form-item :label="$t('Send To') + '：'">
        <p>
          {{
            $i18n.locale == "zh"
              ? exhibit.exhibitorName
              : exhibit.exhibitorNameEn
          }}
        </p>
      </el-form-item>
      <el-form-item :label="$t('Inquiry Product') + '：'">
        <p>{{ exhibit.name }}</p>
      </el-form-item>
      <el-form-item :label="$t('Inquired Quantity') + '：'">
        <el-input-number
          v-model="askform.quantity"
          :min="1"
          :max="1000"
          :label="$t('Plese Choose Inquired Quantity') + '：'"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('Estimated Order Time') + '：'" required>
        <el-form-item prop="tradingTime">
          <el-date-picker
            :value-format="'timestamp'"
            type="date"
            :placeholder="$t('Year/Month/Day')"
            v-model="askform.tradingTime"
            style="width: 65%"
          ></el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$t('Trade Content') + '：'" prop="description">
        <el-input type="textarea" v-model="askform.description"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Contact Information') + '：'" required>
        <el-col :span="7">
          <el-form-item prop="contactName">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Name')"
              v-model="askform.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactNumber">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Mobile')"
              v-model="askform.contactNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactEmail">
            <el-input
              style="width: 260px"
              :placeholder="$t('Your E-mail')"
              v-model="askform.contactEmail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Company1') + '：'" prop="company">
        <el-input
          style="width: 300px"
          :placeholder="$t('Your Company')"
          v-model="askform.companyName"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          style="width: 220px"
          @click="submitForm('askform')"
          >{{ $t("SUBMIT") }}</el-button
        >
      </el-form-item>
      <div class="ask-img-box row-center">
        <img
          v-if="exhibit.properties && exhibit.properties.albums"
          style="width: 100%"
          :src="exhibit.properties.albums[0]"
        />
      </div>
    </el-form>
    <!-- 询盘和供需 -->
    <el-form
      v-show="dialogtype == 'supply'"
      :model="supplyform"
      :rules="rules"
      ref="supplyform"
      label-width="170px"
    >
      <el-form-item :label="$t('Send To') + '：'">
        <p>{{ exhibitor.name }}</p>
      </el-form-item>
      <el-form-item :label="$t('Inquired Quantity') + '：'">
        <el-input-number
          v-model="supplyform.quantity"
          :min="1"
          :max="1000"
          :label="$t('Plese Choose Inquired Quantity') + '：'"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('Trade Content') + '：'" prop="description">
        <el-input type="textarea" v-model="supplyform.description"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Contact Information') + '：'" required>
        <el-col :span="7">
          <el-form-item prop="contactName">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Name')"
              v-model="supplyform.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactNumber">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Mobile')"
              v-model="supplyform.contactNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactEmail">
            <el-input
              style="width: 260px"
              :placeholder="$t('Your E-mail')"
              v-model="supplyform.contactEmail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Company1') + '：'" prop="company">
        <el-input
          style="width: 300px"
          :placeholder="$t('Your Company')"
          v-model="supplyform.companyName"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          style="width: 220px"
          @click="submitForm('supplyform')"
          >{{ $t("SUBMIT") }}</el-button
        >
      </el-form-item>
      <div class="ask-img-box row-center">
        <img src="https://via.placeholder.com/177x163.png" />
      </div>
    </el-form>
    <!-- 求购 -->
    <el-form
      v-show="dialogtype == 'demand'"
      :model="demandform"
      :rules="rules"
      ref="demandform"
      label-width="170px"
    >
      <el-form-item :label="$t('Inquired Quantity') + '：'">
        <el-input-number
          v-model="demandform.quantity"
          :min="1"
          :max="1000"
          :label="$t('Plese Choose Inquired Quantity') + '：'"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('Trade Content') + '：'" prop="description">
        <el-input type="textarea" v-model="demandform.description"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Contact Information') + '：'" required>
        <el-col :span="7">
          <el-form-item prop="contactName">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Name')"
              v-model="demandform.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactNumber">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Mobile')"
              v-model="demandform.contactNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactEmail">
            <el-input
              style="width: 260px"
              :placeholder="$t('Your E-mail')"
              v-model="demandform.contactEmail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Companc y1') + '：'" prop="company">
        <el-input
          style="width: 300px"
          :placeholder="$t('Your Company')"
          v-model="demandform.companyName"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          style="width: 220px"
          @click="submitForm('supplyform')"
          >{{ $t("SUBMIT") }}</el-button
        >
      </el-form-item>
      <div class="ask-img-box row-center">
        <img src="https://via.placeholder.com/177x163.png" />
      </div>
    </el-form>
    <div slot="title" class="dialog-header">
      <div class="row-between dialog-header-box">
        <p class="dialog-header-title" v-show="dialogtype == 'contactbusiness'">
          {{ $t("Contact Company") }}
        </p>
        <p class="dialog-header-title" v-show="dialogtype == 'contactmain'">
          {{ $t("Contact ChinaCycle") }}
        </p>
        <p
          class="dialog-header-title"
          v-show="dialogtype == 'reserve'"
          :style="$i18n.locale == 'zh' ? '' : 'font-size: 20px;'"
        >
          {{ $t("Send Invitation2") }}
        </p>
        <p
          class="dialog-header-title"
          v-show="dialogtype == 'ask'"
          :style="$i18n.locale == 'zh' ? '' : 'font-size: 24px;'"
        >
          {{ $t("Send Inquiry") }}
        </p>
        <p
          class="dialog-header-title"
          v-show="dialogtype == 'supply'"
          :style="$i18n.locale == 'zh' ? '' : 'font-size: 15px;'"
        >
          {{ $t("Publish Transaction") }}
        </p>
        <p class="dialog-header-description">
          {{
            $t(
              "Please leave your description so that the enterprise can confirm the reservation information with you!"
            )
          }}
        </p>
        <p class="dialog-header-title" v-show="dialogtype == 'demand'">
          {{ $t("SUBMIT") }}
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapGetters, mapActions } from "vuex";
import {
  publish,
  reserve,
  enquiry,
  getExhibitDetail,
  getExhibitorDetail
} from "@/http/api";

import { checkPhoneValid, checkEmailValid } from "@/libs/utils";

export default {
  data() {
    return {
      contactbusinessform: {
        exhibitor: {
          id: ""
        },
        type: "EXHIBITOR",
        description: "",
        contactName: "",
        contactNumber: "",
        companyName: "",
        // "visitor": {
        //     "id": this.$utils.getVisitorId()
        // }
        user: {}
      },
      contactmainform: {
        // sponsor: {},
        type: "SPONSOR",
        description: "",
        contactName: "",
        contactNumber: "",
        companyName: "",
        // "visitor": {
        //     "id": this.$utils.getVisitorId()
        // },
        user: {}
      },
      reserveform: {
        exhibitor: {
          id: ""
        },
        type: "APPOINTMENT",
        description: "",
        contactName: "",
        contactNumber: "",
        companyName: "",
        // "visitor": {
        //     "id": this.$utils.getVisitorId()
        // }
        user: {}
      },
      askform: {
        // exhibit: {
        //   id: ""
        // },
        exhibitId: "",
        quantity: 0,
        description: "",
        contactName: "",
        contactNumber: "",
        // visitor: {
        //   id: this.$utils.getVisitorId(),
        // },
        user: {}
      },
      supplyform: {
        picture: "www.picture.unknow",
        type: "SUPPLY",
        quantity: 1000,
        description: "本公司可以提供1000个该种零件，质优价低速联系",
        contactName: "张三",
        contactNumber: "17714363284",
        companyName: "张伟自行车配件加工厂",
        // visitor: {
        //   id: this.$utils.getVisitorId(),
        // },
        user: {}
      },
      demandform: {
        contactName: "",
        contactNumber: "",
        companyName: ""
      },
      rules: {
        contactName: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ],
        contactNumber: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              debugger;
              if (value === "" || value === undefined || value === null) {
                callback();
              } else if (!checkPhoneValid(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        contactEmail: [
          {
            validator: (rule, value, callback) => {
              debugger;
              if (value === "" || value === undefined || value === null) {
                callback();
              } else if (!checkEmailValid(value)) {
                callback(new Error("请输入正确的邮箱"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        companyName: [
          { required: true, message: "请填写公司名称", trigger: "blur" }
        ],
        quantity: [
          { required: true, message: "请填写采购数量", trigger: "blur" }
        ],
        description: [
          { required: true, message: "请填写需求描述", trigger: "blur" }
        ],
        picture: [{ required: true, message: "请上传图片", trigger: "change" }]
      },
      formLabelWidth: "120px",
      exhibit: {
        exhibitor: {
          name: ""
        },
        properties: {
          alubms: [""]
        }
      },
      exhibitor: {}
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    ...mapGetters({})
  },
  mounted() {
    console.log("==========----------============");
    this.init();
  },
  watch: {
    // // exhibitid: async function(val) { },
    // dialogFormVisible: async function() {
    // }
  },
  props: {
    exhibitorId: {
      type: String
    },
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    dialogtype: {
      type: String,
      default: ""
    },
    exhibitid: {
      type: String,
      default: ""
    }
  },
  methods: {
    async init() {
      switch (this.dialogtype) {
        case "contactbusiness":
          this.contactbusinessform.user = {
            id: this.user.id
          };
          break;
        case "contactmain":
          this.contactmainform.user = {
            id: this.user.id
          };
          break;
        case "reserve":
          this.reserveform.user = {
            id: this.user.id
          };
          break;
        case "ask":
          this.askform.user = {
            id: this.user.id
          };
          break;

        default:
          break;
      }
      const val = this.exhibitid;
      if (val) {
        if (
          this.dialogtype == "contactbusiness" ||
          this.dialogtype == "reserve"
        ) {
          const exhibitor = await getExhibitorDetail(val);
          this.exhibitor = exhibitor;
        } else {
          const exhibit = await getExhibitDetail(val);
          this.exhibit = exhibit;
          console.log(this.dialogtype, val, "--");
        }

        switch (this.dialogtype) {
          case "contactbusiness":
            this.contactbusinessform.exhibitor = {
              id: val
            };
            this.contactbusinessform.user = {
              id: this.user.id
            };
            break;
          case "contactmain":
            this.contactmainform.user = {
              id: this.user.id
            };
            break;
          case "reserve":
            this.reserveform.exhibitor = {
              id: val
            };
            this.reserveform.user = {
              id: this.user.id
            };
            break;
          case "ask":
            // this.askform.exhibit = {
            //   id: val
            // };
            this.askform.exhibitId = val;
            this.askform.creatorId = this.user.id;
            this.askform.exhibitorId = this.exhibitorId;

            // this.askform.user = {
            //   id: this.user.id
            // };
            break;

          default:
            break;
        }
      }
    },
    async publishMsg(data) {
      const params = {
        ...data,
        publishType: data.type
      };
      params.exhibitorId = data.exhibitor.id;
      delete params.exhibitor;
      params.tradingTime = dayjs(params.tradingTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const res = await reserve({ ...params });
    },
    async askMsg(data) {
      try {
        const params = {
          ...data
        };
        params.tradingTime = dayjs(params.tradingTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        delete params.user;
        const res = await enquiry({ ...params });
      } catch (error) {
        console.error(error);
      }
    },
    submitForm(formName) {
      try {
        this.$refs[formName].validate(valid => {
          if (valid) {
            switch (this.dialogtype) {
              case "contactbusiness":
                this.publishMsg(this.contactbusinessform);
                break;
              case "contactmain":
                this.publishMsg(this.contactmainform);
                break;
              case "reserve":
                debugger;
                this.publishMsg(this.reserveform);
                break;
              case "ask":
                debugger;
                this.askMsg(this.askform);
                break;
              case "supply":
                this.publishMsg(this.supplyform);
                break;

              default:
                break;
            }
            this.$emit("handleCloseDialog", false);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    handleClose() {
      // this.submitForm
      this.$emit("handleCloseDialog", false);
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__headerbtn {
  border: 1px solid #aaa;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  line-height: 20px;
}
.dialog-header-box {
  border-bottom: 1px solid #aaaaaa;
  .dialog-header-title {
    font-size: 30px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    border-bottom: 2px solid #619a37;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .dialog-header-description {
    font-size: 14px;
    font-family: FZLanTingHei-R-GBK;
    font-weight: 400;
    color: #999999;
  }
}
/deep/ .el-dialog__header {
  padding: 20px 80px 10px;
}
/deep/ .el-dialog__body {
  padding: 30px 80px;
}
/deep/ .el-button--primary {
  background-color: #619a37;
  border-color: unset;
}
.ask-img-box {
  position: absolute;
  right: 115px;
  top: 120px;
  width: 190px;
  height: 190px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialoglist.vue